import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from "react-router-dom-v5-compat";
/**
 * Component that conditionally renders a link around an other components if there is a URL.
 *
 * @param url
 * @returns
 */
export const ConditionalLink = ({ url = "", className, children }) => {
    if (url !== "") {
        return (_jsx(Link, Object.assign({ to: url, rel: "noopener noreferrer", className: className, style: { textDecoration: "none" } }, { children: children })));
    }
    else {
        return _jsx(_Fragment, { children: children });
    }
};
/**
 * Function that sets homeURL to site root if url is indefined
 *
 * @param url
 * @returns
 */
export function maybeChangeHomeUrl(url) {
    return url !== null && url !== void 0 ? url : "/";
}
